"use client"

import { useEffect, useState } from "react"

export function useVisibilityChange() {
  const [isVisible, setIsVisible] = useState(() => {
    // During SSR, assume the page is visible to avoid hydration mismatches
    if (typeof document === "undefined") {
      return true
    }
    return !document.hidden
  })

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsVisible(!document.hidden)
    }

    document.addEventListener("visibilitychange", handleVisibilityChange)

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    }
  }, [])

  return isVisible
}
